module.exports = __webpack_public_path__ + "media/images/payments/solo-21aa78abc4777c516a9e6776ed2b7f41.svg";